import React, { useEffect, useState } from "react";
import Header from "../../Components/Header";
import Footer from "../../Components/Footer";
import { faqApis } from "../../Data/axios";
import FadeInSection from "../../Components/FadeInSection";

const FAQ = () => {
  const [faqs, setFaqs] = useState([]);
  const [openIndex, setOpenIndex] = useState(null);

  useEffect(() => {
    const fetchFaqs = async () => {
      try {
        const response = await faqApis.getAll();
        console.log("FAQs response:", response.data);
        console.log(response);
        setFaqs(response.data); // Ensure response data is correctly accessed
      } catch (error) {
        console.error("Error fetching FAQs:", error);
      }
    };

    fetchFaqs();
  }, []);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <>
      <Header />
      <div className="bg-topo-bg">
      <div className="container mx-auto font-ubuntu py-16 min-h-[50vh]">
        <hr />
        <div className="text-center mb-12 mt-4">
          <h2 className="text-csyellow text-4xl font-bold mb-4">Frequently Asked Questions</h2>
          <p className="text-gray-700 text-lg font-light text-left">
            Can't find what you're looking for? Chat with our friendly team!
          </p>
        </div>
        <FadeInSection animationType="up">
        <div className="border-t border-gray-300 pt-6">
          {faqs.map((faq, index) => (
            <div key={index} className="mb-6">
              <div
                className="flex justify-between items-center cursor-pointer bg-gray-100 p-4 rounded-lg shadow-md hover:bg-gray-200 transition-all"
                onClick={() => toggleFAQ(index)}
              >
                <h3 className="text-black font-medium text-lg">{faq.question}</h3>
                <i
                  className={`fa-solid text-csgreendark text-lg transition-transform ${openIndex === index ? "fa-chevron-up" : "fa-chevron-down"}`}
                ></i>
              </div>
              {openIndex === index && (
                <div className="mt-4 px-4 text-gray-700 text-base font-light">
                  {faq.answer}
                </div>
              )}
            </div>
          ))}
        </div>
        </FadeInSection>
      </div>
      </div>
      <Footer />
    </>
  );
};

export default FAQ;